import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-textbox',
    templateUrl: './textbox.component.html',
    styleUrls: ['./textbox.component.scss'],
    standalone: false
})
export class TextBoxComponent implements OnInit, OnChanges  {
  @ViewChild('divEl') divEl: ElementRef<HTMLDivElement>;
  @ViewChild('valEl') valEl: NgModel;

  @Input() model: string;
  @Output() modelChange = new EventEmitter<string>();

  @Input() placeholder: string = "";
  @Input() title: string = "";
  @Input() textboxWidth: string = '200px';
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() maxlength: number = 0;
  @Input() minlength: number = 0;
  @Input() pattern: string = '';
  @Input() type: string = 'text';
  @Input() readonly: boolean = false;
  @Input() tabindex: number = 0;
  @Input() multiline: boolean = false;
  @Input() rows: number = 3;

  @Input()  valid: boolean = false;
  @Output() validChange = new EventEmitter<boolean>();

  isFocus: boolean;

  constructor() { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges) {
     if (changes.model && changes.model.currentValue !== changes.model.previousValue) {
        this.valueChange(changes.model.currentValue);
     }
  }

  onEnter() {
    this.isFocus = false;
  }

  onBlur() {
    this.isFocus = false;
  }

  valueChange(value) {

    if (this.valEl) {
      setTimeout(() => {
        this.valid = !this.valEl.control.invalid;
        this.validChange.emit(this.valid);
        this.modelChange.emit(this.model);
      }, 0);
    }
  }
}
